import { Link, useSearchParams } from 'react-router-dom';
import { XCircle, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function PaymentCancelledPage() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');

  return (
    <div data-testid="payment-cancelled-page" className="max-w-lg mx-auto px-4 py-24 text-center">
      <div className="w-20 h-20 rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-8 animate-fade-up">
        <XCircle className="h-10 w-10 text-destructive" />
      </div>
      <h1 className="font-heading text-4xl font-light text-foreground tracking-tight mb-4 animate-fade-up stagger-1">
        Payment Cancelled
      </h1>
      <p className="font-body text-base text-foreground/70 mb-2 animate-fade-up stagger-2">
        No charges were made.
      </p>
      <p className="font-body text-sm text-foreground/60 mb-8 animate-fade-up stagger-2">
        Your order is safely saved as <span className="text-gold font-semibold">unpaid</span>.
        Resume payment from your profile whenever you're ready.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center animate-fade-up stagger-3">
        <Link to={orderId ? `/orders/${orderId}` : '/profile'} data-testid="resume-payment-link">
          <Button variant="ctaPrimary" className="rounded-full px-8 py-6 font-body text-sm font-semibold">
            Resume Payment <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </Link>
        <Link to="/shop">
          <Button variant="ctaSecondary" className="rounded-full px-8 py-6 font-body text-sm">
            Continue Shopping
          </Button>
        </Link>
      </div>
    </div>
  );
}
